import { render, staticRenderFns } from "./setPaidInfo.vue?vue&type=template&id=49a0f3dd"
import script from "./setPaidInfo.vue?vue&type=script&lang=ts"
export * from "./setPaidInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports